module.exports = __webpack_public_path__ + "img/orange-graph.983606ee.png";